<template>
  <div>
    <div
      class="mt-20 pb-20 pt-16 lg:pb-0 lg:pt-20 lg:pl-6 xl:pl-6 md:pl-6 bg-white"
      ref="main"
    >
      <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-full mt-4">
        <div class="h-64">
          <graphic-base height="100%" width="100%" :viewBox="'0 0 204 270'">
            <graphic404 />
          </graphic-base>
        </div>
        <div class="bg-white px-4">
          <div class="title_403"> {{$t('message.Errors.404.title_404')}} </div>
          <div class="sub_title_403"> {{$t('message.Errors.404.sub_title_404')}} </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import graphic404 from '@/components/commons/Illustrations/graphicSVG/404'

export default {

  components: {
    graphicBase,
    graphic404,
  }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";

.title_403{
  width: 100%;
  font-size: 1.5em;
  text-align: center;
  color: $bluePrimary;
  font-weight: 500;
  margin: auto;
  margin-top: 1em;
}
.sub_title_403{
	margin-top: 2%;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 18px;
	color: $text-secondary;
	text-align: center;
}
</style>